<template>
  <input
    :value="displayValue"
    class="price-input"
    type="text"
    inputmode="decimal"
    @input="handleInput"
    @blur="handleBlur"
  />
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String, null],
      default: null
    }
  },
  data() {
    return {
      localValue: ""
    };
  },
  computed: {
    displayValue() {
      if (this.localValue !== "") return this.localValue;
      if (this.value == null) return "";
      return this.formatCurrency(this.value / 100);
    }
  },
  watch: {
    value() {
      this.localValue = "";
    }
  },
  methods: {
    formatCurrency(val) {
      return "$" + Number(val).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleInput(e) {
      this.localValue = e.target.value;
    },
    handleBlur() {
      const raw = this.localValue.replace(/[^0-9.]/g, "");
      const num = parseFloat(raw);
      if (!isNaN(num)) {
        const cents = parseFloat((num * 100).toFixed(0));
        this.$emit("price-change", cents);
      }
      this.localValue = "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
